import React, { useState, useEffect } from "react";
import { Table, Button, Card, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { FaEdit, FaUserPlus } from "react-icons/fa";
import useAuth from "../hooks/useAuth";

function UserList() {
	const [users, setUsers] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const { user: currentUser } = useAuth();

	useEffect(() => {
		fetchUsers();
	}, []);

	const fetchUsers = async () => {
		try {
			setLoading(true);
			const response = await axios.get("/api/users");
			setUsers(response.data.users);
			setError(null);
		} catch (error) {
			console.error("Failed to fetch users:", error);
			setError(error.response?.data?.message || "Failed to load users");
		} finally {
			setLoading(false);
		}
	};

	if (loading) {
		return <div className="text-center py-5">Loading...</div>;
	}

	return (
		<div className="user-list-page">
			<div className="d-flex justify-content-between align-items-center mb-4">
				<h1>User Management</h1>
			</div>

			{error && (
				<Alert variant="danger" className="mb-4">
					{error}
				</Alert>
			)}

			<Card>
				<Card.Body>
					<Table responsive hover>
						<thead>
							<tr>
								<th>Username</th>
								<th>Email</th>
								<th>Role</th>
								<th>Created</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{users.map((user) => (
								<tr key={user.id}>
									<td>{user.username}</td>
									<td>{user.email}</td>
									<td>
										<span className={`badge bg-${user.role === "admin" ? "danger" : "primary"}`}>{user.role}</span>
									</td>
									<td>{new Date(user.created_at).toLocaleDateString()}</td>
									<td>
										<Button as={Link} to={`/admin/users/${user.id}`} variant="outline-primary" size="sm" disabled={user.id === currentUser?.id}>
											<FaEdit /> Edit
										</Button>
									</td>
								</tr>
							))}
						</tbody>
					</Table>

					{users.length === 0 && <p className="text-center text-muted my-4">No users found.</p>}
				</Card.Body>
			</Card>
		</div>
	);
}

export default UserList;
